var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,8.1c-0.3-0.2-0.3-0.6,0-0.8l4.3-2.5c0.1-0.1,0.3-0.1,0.4,0l4.4,2.5c0.3,0.2,0.3,0.6,0,0.8l-4.4,2.5 c-0.1,0.1-0.3,0.1-0.4,0L11.4,8.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,14.5c-0.1-0.1-0.2-0.2-0.2-0.4v-5c0-0.3,0.4-0.5,0.7-0.4l4,2.3c0.1,0.1,0.2,0.2,0.2,0.4v5 c0,0.3-0.4,0.6-0.7,0.4L11,14.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,8.8c0.3-0.2,0.7,0,0.7,0.4v5c0,0.2-0.1,0.3-0.2,0.4l-4.2,2.3c-0.3,0.2-0.7,0-0.7-0.4v-5 c0-0.2,0.1-0.3,0.2-0.4L20.6,8.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,18.4c-0.3-0.2-0.3-0.6,0-0.8l4.3-2.5c0.1-0.1,0.3-0.1,0.4,0l4.4,2.5c0.3,0.2,0.3,0.6,0,0.8l-4.4,2.5 c-0.1,0.1-0.3,0.1-0.4,0L5.7,18.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,24.9C5.1,24.8,5,24.6,5,24.5v-5c0-0.3,0.4-0.5,0.7-0.4l4,2.3c0.1,0.1,0.2,0.2,0.2,0.4v5 c0,0.3-0.4,0.5-0.7,0.4L5.2,24.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,19.1c0.3-0.2,0.7,0,0.7,0.4v5c0,0.2-0.1,0.3-0.2,0.4l-4.2,2.3c-0.3,0.2-0.7,0-0.7-0.4v-5 c0-0.2,0.1-0.3,0.2-0.4L14.8,19.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,17.7c-0.3,0.2-0.3,0.6,0,0.8l4.3,2.5c0.1,0.1,0.3,0.1,0.4,0l4.4-2.5c0.3-0.2,0.3-0.6,0-0.8l-4.4-2.5 c-0.1-0.1-0.3-0.1-0.4,0L17.2,17.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,24.5c0,0.2,0.1,0.3,0.2,0.4l4,2.3c0.3,0.2,0.7,0,0.7-0.4v-5c0-0.2-0.1-0.3-0.2-0.4l-4-2.3 c-0.3-0.2-0.7,0-0.7,0.4V24.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,19.5c0-0.3-0.4-0.5-0.7-0.4l-4.2,2.3c-0.1,0.1-0.2,0.2-0.2,0.4v5c0,0.3,0.4,0.5,0.7,0.4l4.2-2.3 c0.1-0.1,0.2-0.2,0.2-0.4V19.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d80ce5235d77d29706b91f5eab1771d7.svg";
export { ForwardRef as ReactComponent };